
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/ee-grid.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-weet-ee-grid-demo-ee-grid"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/ee-grid.md?type=demo')
};